import { LinearProgressLayout, ProgressLayout } from "./MessagePanel.style";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { UploadProgress } from "hhn-commons";

const UploadProgressBar = ({
  progressData,
  isUploadFailed,
}: {
  progressData?: UploadProgress;
  isUploadFailed?: boolean;
}) => {
  return (
    <>
      {!isUploadFailed &&
        !!progressData &&
        progressData.totalFiles !== progressData.uploadedFiles && (
          <ProgressLayout data-testid="progress-upload">
            <Typography variant="body2">
              Uploaded {progressData.uploadedFiles} of {progressData.totalFiles}
            </Typography>
            <LinearProgressLayout
              variant="determinate"
              value={progressData.uploadPct}
            />
            <IconButton style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon fontSize="small"></CloseIcon>
            </IconButton>
          </ProgressLayout>
        )}
    </>
  );
};

export default UploadProgressBar;
